import {
  BrowserRouter,
  Routes,
  Route
} from 'react-router-dom'

import '@komponentkassen/svv-base-css/dist/main.css';
import '@komponentkassen/svv-step-indicator-css/dist/main.css';
import '@komponentkassen/svv-button-css/dist/main.css';
import '@komponentkassen/svv-form-css/dist/main.css';
import '@komponentkassen/svv-datepicker-css/dist/main.css'
import '@komponentkassen/svv-definition-list-css/dist/main.css'
import '@komponentkassen/svv-tokens/dist/external/tokens.css'
import '@komponentkassen/svv-layout-css/dist/main.css'
import '@komponentkassen/svv-text-css/dist/main.css'

import './App.css';

//Components
import Book from "./pages/book/Book";
import Rebook from './pages/rebook/Rebook';
import Cancel from './pages/cancel/Cancel';
import Reconfirm from "./pages/reconfirm/Reconfirm";
import Index from "./pages/shared/Index";

function App() {
  let basename = window.location.pathname;
  const rootElement = document.getElementById("root");
  
  if (rootElement && rootElement.dataset.baseurl) {
    basename = rootElement.dataset.baseurl  
  }
  
  let tjeneste = ""
  if (rootElement && rootElement.dataset.tjeneste) {
    tjeneste = rootElement.dataset.tjeneste
  }
  
  let flyt = ""
  if (rootElement && rootElement.dataset.flyt) {
    flyt = rootElement.dataset.flyt
  }

  let avbrytUrl = ""
  if (rootElement && rootElement.dataset.avbrytUrl) {
    avbrytUrl = rootElement.dataset.avbrytUrl
  }

  return (
    <>
      <BrowserRouter
        basename={basename}
      >
        <Routes>
          <Route
            path="/"
            element={<Index flyt={flyt}/>}
          />
          <Route 
            path="bestill/*"
            element={<Book tjeneste={tjeneste} avbrytUrl={avbrytUrl}/>}
          />
          <Route 
            path="endre/*"
            element={<Rebook avbrytUrl={avbrytUrl}/>}
          />
          <Route 
            path="avbestill/*"
            element={<Cancel />} 
          />
          <Route 
            path="resend/*" 
            element={<Reconfirm />} 
          />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;